import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 578,
	height: 168,
	viewBox: "0 0 578 168",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M461.865 124.482L446.342 140M461.865 140L446.342 124.482M119.529 129.453H100.191M109.861 139.117V119.788M437.792 28L423.871 41.9171M437.792 41.9171L423.871 28M533.763 97.7388C531.766 100.559 530.418 103.776 530.029 107.271C528.997 115.853 533.751 124.208 539.588 130.621C542.124 133.474 545.072 136.1 548.61 137.648C552.472 139.394 557.551 139.933 561.755 139.662C565.748 139.399 569.911 138.075 572.64 135.121C575.57 131.947 576.549 127.374 576.905 123.037C577.236 118.068 576.718 112.921 575.054 108.136C573.508 103.662 569.799 100.433 566.611 97.0789C559.903 89.9612 549.25 87.006 540.385 91.9947C537.595 93.3699 535.46 95.352 533.763 97.7388ZM69.7557 44.9314C67.8762 40.8061 65.1193 37.1531 61.4129 34.4032C52.3624 27.5648 39.7479 27.4342 28.619 29.8124C23.7089 30.8016 18.7838 32.4084 14.6913 35.3954C10.1601 38.6187 6.19485 44.0187 3.72504 48.962C1.38482 53.6613 0.136336 59.2531 1.68441 64.297C3.34715 69.7145 7.88618 73.8447 12.5697 77.1134C17.986 80.7712 24.1651 83.583 30.6904 84.8587C36.7846 86.0619 42.8961 83.9905 48.8057 82.5937C61.3079 79.6938 71.696 69.5731 71.8948 56.2311C72.1788 52.16 71.3411 48.4315 69.7557 44.9314Z",
			stroke: "#ACD4FF",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1848_37479)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 206.312,
					y: 34.125,
					width: 165.375,
					height: 42,
					rx: 4,
					fill: "#ACD4FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.312,
					y: 91.875,
					width: 107.625,
					height: 42,
					rx: 4,
					fill: "#ACD4FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M309.917 131.638C312.365 129.716 313.938 126.729 313.938 123.375V102.375C313.938 96.576 309.237 91.875 303.438 91.875H254.506C255.17 95.075 256.157 98.2571 257.484 101.38C266.466 122.515 288.207 134.321 309.917 131.638Z",
					fill: "#006ADC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M253.779 76.125H353.767C353.236 71.3885 352.018 66.6482 350.058 62.0369C344.246 48.3608 333.091 38.5907 320.059 34.125H287.477C286.345 34.514 285.218 34.9459 284.099 35.4215C266.795 42.7759 255.743 58.684 253.779 76.125Z",
					fill: "#006ADC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M321.765 126.202C347.222 115.382 359.089 85.9743 348.27 60.5167C337.451 35.0592 308.043 23.1925 282.585 34.0117C257.128 44.8309 245.261 74.239 256.08 99.6965C266.899 125.154 296.307 137.021 321.765 126.202Z",
					stroke: "#002E5F",
					strokeWidth: 4,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M339.312 115.775L367.312 143.775",
					stroke: "#002E5F",
					strokeWidth: 4,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1848_37479",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 168,
				height: 168,
				fill: "white",
				transform: "translate(205)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSearch);
export default ForwardRef;
